var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-card"},[_c('SummaryCart',{attrs:{"is-show-detail-price":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }